import React from 'react';

export const Option = (props) => {
  const { label, ariaLabel, value, ...rest } = props;
  // eslint-disable-next-line no-unused-vars
  const { isOutOfStock, htmlContent, isHiddenFromDropdown, ...clearedRest } =
    rest;
  return (
    <option {...clearedRest} aria-label={ariaLabel} value={value}>
      {label}
    </option>
  );
};
